import Vue from "vue";
import App from "./App.vue";
import store from "./store/index";
import router from "./router/index";
import "./registerServiceWorker";

import "./plugins/mixins";
import "./plugins/plugins";
import "./plugins/others";
import "./plugins/fontawesome";

Vue.config.productionTip = false;

import AppProperty from "@/components/Property";
import AppEditItem from "@/components/datasource/EditItem";

Vue.component("app-property", AppProperty);
Vue.component("app-edit-item", AppEditItem);

import VueWait from 'vue-wait';
Vue.use(VueWait);

new Vue({
  router,
  store,
  wait: new VueWait({
    // Defaults values are following:
    useVuex: true, // Uses Vuex to manage wait state
    vuexModuleName: 'wait', // Vuex module name
  }),
  render: h => h(App)
}).$mount("#app");